import * as axios from 'axios';


function getAllBillings(limit, offset) {

    const params = {}
    if (limit !== undefined) params.limit = limit
    if (offset !== undefined) params.offset = offset

    const url = `/admin/locations/billings`;
    return axios.get(url, { params })
        // get data
        .then(x => x.data)
        // add url field
        .then(x => {
            if (x.status == 'error') {
                return Promise.reject(x);
            }
            return x
        });
}

function getAllBillingsOpen() { 

    const data = {  }

    const url = `/admin/locations/billings-open`;
    return axios.get(url, data)
        // get data
        .then(x => x.data)
        // add url field
        .then(x => {
            if (x.status == 'error') {
                return Promise.reject(x);
            }
            return x
        });
}


function searchBillingsByInvoiceNrs(invoiceNrs) {
    const url = `/admin/locations/billings-by-invoice-nrs`;
    return axios.post(url, { invoice_nrs: invoiceNrs })
        .then(x => x.data)
        .then(x => {
            if (x.status == 'error') {
                return Promise.reject(x);
            }
            return x
        });
}

export { getAllBillings, getAllBillingsOpen, searchBillingsByInvoiceNrs }